var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNaborLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_5441",
    "data-name": "Group 5441",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 270.25,
    height: 121,
    viewBox: "0 0 270.25 121",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2706",
    "data-name": "Rectangle 2706",
    width: 270.25,
    height: 121,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2705",
    "data-name": "Rectangle 2705",
    width: 270.25,
    height: 121.001,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-3"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2704",
    "data-name": "Rectangle 2704",
    width: 31.701,
    height: 62.107,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_5440",
    "data-name": "Group 5440",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5439",
    "data-name": "Group 5439",
    transform: "translate(0 -0.001)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5438",
    "data-name": "Group 5438",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5914",
    "data-name": "Path 5914",
    d: "M101.509,42.527c0,5.9-.01,11.806,0,17.711A54.238,54.238,0,0,1,88.347,96.226a77.4,77.4,0,0,1-22.71,18.34c-4.087,2.211-8.383,4.034-12.617,5.96a5.854,5.854,0,0,1-4.8-.087A94.242,94.242,0,0,1,17.564,100.4C9.527,92.435,3.727,83.121,1.246,71.934A71.2,71.2,0,0,1,.053,56.479C.039,44.554.06,32.63,0,20.706a5.977,5.977,0,0,1,2.8-5.472A97.781,97.781,0,0,1,20.289,6.127,87.635,87.635,0,0,1,39.794.755,74.56,74.56,0,0,1,56.477.235c12.181.866,23.5,4.643,34.241,10.288,2.838,1.5,5.532,3.266,8.278,4.929a5.248,5.248,0,0,1,2.515,4.879q-.012,11.1,0,22.2",
    transform: "translate(0 0.002)",
    fill: "#edeeef"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5915",
    "data-name": "Path 5915",
    d: "M94.83,40.945c0,5.424-.01,10.846,0,16.271A49.843,49.843,0,0,1,82.738,90.279a71.1,71.1,0,0,1-20.864,16.85c-3.754,2.03-7.7,3.706-11.594,5.474a5.381,5.381,0,0,1-4.407-.079A86.67,86.67,0,0,1,17.707,94.117C10.326,86.8,5,78.239,2.717,67.96a65.416,65.416,0,0,1-1.1-14.2c-.013-10.954.008-21.91-.047-32.864a5.489,5.489,0,0,1,2.568-5.026A89.744,89.744,0,0,1,20.212,7.5,80.548,80.548,0,0,1,38.13,2.57,68.569,68.569,0,0,1,53.46,2.09c11.19.8,21.59,4.268,31.456,9.453,2.607,1.372,5.083,3,7.607,4.53a4.818,4.818,0,0,1,2.311,4.48q-.008,10.194,0,20.392",
    transform: "translate(2.553 3.045)",
    fill: "#003189"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5916",
    "data-name": "Path 5916",
    d: "M87.228,52.94q-.016-8.137,0-16.271,0-10.194,0-20.392c0-.176-.01-.346-.021-.517-10.424-5.839-21.433-9.918-33.491-11a63.347,63.347,0,0,0-18.49,1.06A89.041,89.041,0,0,0,7.165,16.98a1.63,1.63,0,0,0-.889,1.637c.031,7.106.018,14.212.016,21.317,0,4.561-.092,9.126.029,13.682A85.352,85.352,0,0,0,7.084,65.3c1.388,8.318,5.238,15.565,10.639,21.984C25.107,96.055,34.2,102.515,44.3,107.6c3.36-1.508,6.739-3,9.97-4.745A71.1,71.1,0,0,0,75.133,86,49.829,49.829,0,0,0,87.228,52.94",
    transform: "translate(10.157 7.318)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5917",
    "data-name": "Path 5917",
    d: "M87.228,52.94q-.016-8.137,0-16.271,0-10.194,0-20.392c0-.176-.01-.346-.021-.517-10.424-5.839-21.433-9.918-33.491-11a63.347,63.347,0,0,0-18.49,1.06A89.041,89.041,0,0,0,7.165,16.98a1.63,1.63,0,0,0-.889,1.637c.031,7.106.018,14.212.016,21.317,0,4.561-.092,9.126.029,13.682A85.352,85.352,0,0,0,7.084,65.3c1.388,8.318,5.238,15.565,10.639,21.984C25.107,96.055,34.2,102.515,44.3,107.6c3.36-1.508,6.739-3,9.97-4.745A71.1,71.1,0,0,0,75.133,86,49.829,49.829,0,0,0,87.228,52.94Z",
    transform: "translate(10.157 7.318)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5918",
    "data-name": "Path 5918",
    d: "M47.043,68.334h.31c-.63-6.862-.986-13.823-1.173-21.1l-20.819-41A65,65,0,0,0,15.65,7.335Z",
    transform: "translate(25.401 10.109)",
    fill: "#146bb4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5919",
    "data-name": "Path 5919",
    d: "M31.16,7.626l.018,3.518,3.843,1.611V78.086c-.711,4.811-3.533,6.883-4.895,9.225.4.233.8.462,1.207.677a60.123,60.123,0,0,0,7.659-8.027,45.432,45.432,0,0,0,5.939-9.16,17.494,17.494,0,0,0,1.277-6.951V17.339A5.147,5.147,0,0,0,43.2,12.321a66.067,66.067,0,0,0-12.04-4.7",
    transform: "translate(48.897 12.378)",
    fill: "#003189"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5920",
    "data-name": "Path 5920",
    d: "M19.919,26.987l-5.981-13.21V73.651c3.546,3.072,7.373,5.776,7.373,5.776V75.146l-1.474-1.632Z",
    transform: "translate(22.622 22.362)",
    fill: "#207dc2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5921",
    "data-name": "Path 5921",
    d: "M81.835,54.628H73.19L61.42,27.052h-.338a33.358,33.358,0,0,1,.651,6.77V54.628h-6.56V16.56h8.7L75.535,43.848h.286a37.022,37.022,0,0,1-.5-6.51V16.56h6.51Z",
    transform: "translate(89.547 26.879)",
    fill: "#003387"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5922",
    "data-name": "Path 5922",
    d: "M82.891,49.392H74.038c-2.135,0-3.814-.278-5.039-1.873a10.746,10.746,0,0,1-1.836-6.668q0-4.584,2.513-6.809t7.512-2.46l4.375-.157V29.342a3.727,3.727,0,0,0-4.037-4.06,12.03,12.03,0,0,0-5.988,2.03l-2.395-4.79a17.221,17.221,0,0,1,9.4-2.736q4.611,0,7.019,2.644t2.408,7.486V49.392ZM76.876,44.5a15.122,15.122,0,0,0,3.591-.136A1.559,1.559,0,0,0,81.6,42.7l-.037-4.457V35.8l-2.657.1a4.845,4.845,0,0,0-3.476,1.353A5.28,5.28,0,0,0,74.324,40.9q0,3.592,2.552,3.594",
    transform: "translate(109.009 32.115)",
    fill: "#003387"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5923",
    "data-name": "Path 5923",
    d: "M90.326,26.59q3.958,0,6.222,3.932t2.266,11.067q0,7.212-2.277,11.145a6.274,6.274,0,0,1-6.133,3.41H77.229V15.626h6.927L84.3,26.218c0,.4-.228.679,2.463.372a31.67,31.67,0,0,1,3.565,0m-2.395,5.883c-1.319,0-1.545,0-2.19.052a1.557,1.557,0,0,0-1.584,1.715V47.811c0,.729-.2,2.943,1.43,2.943h2.382c2.5,0,3.764-3.124,3.764-9.27q0-9.006-3.8-9.01",
    transform: "translate(125.346 25.363)",
    fill: "#003387"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5924",
    "data-name": "Path 5924",
    d: "M109.426,34.8q0,7.137-3.022,11.106A10.536,10.536,0,0,1,92.24,48.058a11.517,11.517,0,0,1-3.932-5.246,21.33,21.33,0,0,1-1.38-8.008q0-7.055,2.993-11.027A9.825,9.825,0,0,1,98.228,19.8a9.677,9.677,0,0,1,8.163,4.05q3.034,4.049,3.035,10.949m-15.416,0A18.211,18.211,0,0,0,95,41.652a3.315,3.315,0,0,0,3.177,2.319q4.167,0,4.168-9.168a17.578,17.578,0,0,0-1-6.809,3.358,3.358,0,0,0-6.34,0A17.781,17.781,0,0,0,94.01,34.8",
    transform: "translate(141.088 32.145)",
    fill: "#003387"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5925",
    "data-name": "Path 5925",
    d: "M109.8,19.82a10.972,10.972,0,0,1,2.526.5l-.808,6.718a8.515,8.515,0,0,0-1.9-.26c-1.988-.066-3.4.257-4.3,1.584s-.929,3.667-.929,6.2v14.92H97.462l-.155-19s-.354-5.291,3.557-8.417c3.247-2.6,6.521-2.434,8.939-2.251",
    transform: "translate(157.92 32.023)",
    fill: "#003387"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_5437",
    "data-name": "Group 5437",
    transform: "translate(41.051 16.336)",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5436",
    "data-name": "Group 5436"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5435",
    "data-name": "Group 5435",
    clipPath: "url(#clip-path-3)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5926",
    "data-name": "Path 5926",
    d: "M47.043,68.334h.31c-.63-6.862-.986-13.823-1.173-21.1l-20.819-41A65,65,0,0,0,15.65,7.335Z",
    transform: "translate(-15.65 -6.227)",
    fill: "#003189"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_5927",
    "data-name": "Path 5927",
    d: "M95.8,23.516H89.9l2.172-7.89H100Z",
    transform: "translate(145.915 25.363)",
    fill: "#003387"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNaborLogo);
export default __webpack_public_path__ + "static/media/nabor-logo.022ef24e8e16f499d263266142101d9b.svg";
export { ForwardRef as ReactComponent };